import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT } from '../styles'

const RECAP_MEDIUM_BREAKPOINT = 900

export const ShapeContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  @media screen and (max-width: 599px) {
    display: none;
  }
`

export const MdDuskRectangle = styled.img`
  position: absolute;
  left: 0;
  top: 110px;
  @media screen and (max-width: 599px) and (min-width: ${RECAP_XS_BREAKPOINT +
    1}px) {
    left: calc(18vw - 165px);
  }
`

export const SmLightOakCircle = styled.img`
  position: absolute;
  right: 70px;
  top: 250px;
  @media screen and (max-width: 999px) and (min-width: ${RECAP_MEDIUM_BREAKPOINT}px) {
    right: 0;
  }
  @media screen and (max-width: 599px) and (min-width: ${RECAP_XS_BREAKPOINT +
    1}px) {
    right: calc(18vw - 80px);
  }
`

export const MdBeigeVector = styled.img`
  position: absolute;
  right: 0;
  top: 130px;
  @media screen and (max-width: 999px) and (min-width: ${RECAP_MEDIUM_BREAKPOINT}px) {
    right: -60px;
  }
  @media screen and (max-width: 599px) and (min-width: ${RECAP_XS_BREAKPOINT +
    1}px) {
    right: calc(18vw - 165px);
  }
`
